import { CompanyFeature } from '../graphql/graphql-operations';

export const COMPANY_FEATURES = [
  CompanyFeature.LAUNCH_GROUP_SESSION,
  CompanyFeature.PATIENT_LOGIN,
  CompanyFeature.CUSTOM_3D_MODELS,
  CompanyFeature.IMPORT_COMPANY_USERS,
];
